import React, { memo } from 'react'
import styles from './category.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'

const Category = memo(({ classes, category, active, onClick }) => (
  <li
    className={classNames(classes.category, { [classes.active]: active })}
    onClick={onClick}>
    {category.toLowerCase()}
  </li>
))

export default injectSheet(styles)(Category)
